import Category from ".";

export const categoryRoutes = (data) => [
  {
    path: "/admin/categories",
    title: "Page",
    layout: "admin",
    routeType: "admin",
    component: Category,
  },
];
